// extracted by mini-css-extract-plugin
export default {"InnerCard":"InnerCard_InnerCard__h+1oU","Sign":"InnerCard_Sign__Mye4I","Title":"InnerCard_Title__msv8i"};